import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy-dark bg-gold border-2 border-gold-dark rounded-full shadow-[0_8px_24px_rgba(15,42,82,0.22)] hover:bg-gold-light hover:shadow-[0_10px_30px_rgba(217,155,18,0.4)] transition-[background-color,box-shadow,transform] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} data-id="element-56" data-mp="30s1kedsymt28">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} {...props} data-id="element-57" data-mp="3c5nct171nu9">
      {children}
    </motion.button>;
}